// extracted by mini-css-extract-plugin
export var dropdown = "_mv-1";
export var hidden = "_mv-0";